import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const DetailsContainer = styled('span')({
  border: '1px solid #B0B0B0',
  padding: 16,
  maxWidth: '30em',
  display: 'flex',
  borderBottom: 'none',
  '&: first-of-type': {
    borderRadius: '8px 8px 0 0',
  },
  '&: last-of-type': {
    borderRadius: '0 0 8px 8px',
    marginBottom: '54px',
    borderBottom: '1px solid #B0B0B0',
  },
});

export const StatusContainer = styled(Box)({
  textAlign: 'center',
  padding: '4px 6px',
  borderRadius: '20px',
  minWidth: '30%',
  fontFamily: 'montserrat',
  fontSize: '0.9rem',
});

export const DetailTitle = styled(Typography)({
  fontWeight: 700,
  width: '40%',
});
